module.exports = __webpack_public_path__ + "img/traffic-vps.aa00c67.svg";